import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckIcon from "@mui/icons-material/Check";

const benefits = [
    {
        title: "Unify data",
        description:
            "Changes to a global rating reflect across all current templates, reports, and comments automatically.",
    },
    {
        title: "Global access",
        description:
            "Access and update your ratings from any template or active report.",
    },
];

function EnableGlobalRating(props) {
    const { open, onClose, onSubmit } = props;
    return (
        <Dialog
            fullWidth={true}
            className="global-rating-dialog-container"
            open={open}
            onClose={onClose}
            maxWidth="sm"
        >
            <div className="global-rating-header">
                <DialogTitle className="global-rating-title">
                    Use global ratings
                </DialogTitle>
                <div className="global-rating-close-wrapper">
                    <CloseIcon onClick={onClose} />
                </div>
            </div>
            <DialogContent className="global-rating-content">
                <p className="global-rating-description">
                    This is a one time conversion that moves your ratings
                    from individual templates to Global Ratings.
                </p>
                <div className="global-rating-benefit-list">
                    {benefits.map((benefit) => (
                        <div
                            className="global-rating-benefit-row"
                            key={benefit.title}
                        >
                            <div className="global-rating-icon-wrap">
                                <CheckIcon />
                            </div>
                            <div className="global-rating-text-column">
                                <div className="global-rating-benefit-title">
                                    {benefit.title}
                                </div>
                                <div className="global-rating-benefit-description">
                                    {benefit.description}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="global-rating-reassurance">
                    <InfoOutlinedIcon />
                    <span>
                        Your existing workflows, reports, and ratings remain
                        unchanged. Only where your ratings are stored will
                        change.
                    </span>
                </div>
            </DialogContent>
            <DialogActions className="global-rating-actions">
                <Button className="back-btn" onClick={onClose}>
                    Maybe later
                </Button>
                <Button className="default-btn" onClick={onSubmit}>
                    Enable now
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EnableGlobalRating;